import { combineReducers } from 'redux';
import { candidates, CandidateState } from '../containers/CandidatesPane/reducer';
import { surveys, SurveyState } from '../containers/SurveysPane/reducer';
import { positions, PositionState } from '../containers/PositionsPane/reducer';
import { prospects, ProspectState } from '../containers/ProspectsPane/reducer';

export type DashboardState = {
  candidates: CandidateState;
  surveys: SurveyState;
  positions: PositionState;
  prospects: ProspectState;
}

export default combineReducers({
  candidates,
  positions,
  prospects,
  surveys
});
